import { ApplicationStatus } from '@features/applications';

type applicationStatusObject = {
  status: ApplicationStatus;
  buttonText?: string;
};
type interviewTypeCTAsObject = {
  colorToCopy: ApplicationStatus;
  label: string;
  color: string;
  value: string;
};

export const applicationStatuses: applicationStatusObject[] = [
  { status: 'unattended' },
  { status: 'messaged' },
  { status: 'saved' },
  { status: 'interview process' },
  {
    status: 'pending job offers',
    buttonText: 'job offers',
  },
  { status: 'hired' },
  { status: 'declined' },
  { status: 'archived' },
];

export const interviewTypeCTAs: interviewTypeCTAsObject[] = [
  {
    label: 'All Interviews',
    value: '0',
    color: 'secondary',
    colorToCopy: 'interview process',
  },
  {
    label: 'Interview Requested',
    value: '1',
    color: 'yellow',
    colorToCopy: 'unattended',
  },
  {
    label: 'Interview Confirmed',
    value: '2',
    color: 'success',
    colorToCopy: 'saved',
  },
];
